import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { CustomButton } from "components/CustomButton";

function ModalSimplifiedAlert({ open, handleClose, onConfirm, }) {

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ backdropFilter: 'blur(2px)', }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          maxWidth: 504,
          bgcolor: '#FFFFFF',
          p: '25px',
          borderRadius: '10px',
          gap: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box display="flex" alignItems="center" gap="20px" justifyContent="space-between" width='100%' flexDirection='column'>
          <Box
            component="i"
            fontSize="70px"
            color="#4CAF50"
            className="icon-grid_ativo"
          />
          <Typography variant="body1" color="#5D5D5D" fontSize="15px" textAlign="center">
            Agora, falta pouco para aproveitar <strong> todos </strong><br /> os recursos do programa. <br />
            Só completar seus dados no cadastro. É rápido.
          </Typography>

        </Box>

        <Box display="flex" justifyContent="center" width="100%" gap='15px'>
          <CustomButton
            size="sm"
            fullWidth
            variant="contained"
            style={{ maxWidth: '174px' }}
            defaultColor="#5CB860"
            onClick={onConfirm}
          >
            Completar cadastro
          </CustomButton>
          <CustomButton
            size="sm"
            fullWidth
            variant="outlined"
            style={{ maxWidth: '174px', borderColor: '#ffffff' }}
            defaultColor="#F05B4F"
            onClick={handleClose}
          >
            Deixar para depois
          </CustomButton>

        </Box>


      </Box>
    </Modal>
  );
}


export default React.memo(ModalSimplifiedAlert)